import { CompanyPermissions } from "./company-permissions.model";
import { ApplicationPermissions } from "./application-permissions.model";
import { Permission } from "./permission.model";
import {  RolesAndPermissionsApi } from "./roles-and-permissions-api.model";

export class UserRolesAndPermissions {
    applicationPermissions: ApplicationPermissions;
    companyPermissions : CompanyPermissions[] = [];
    isActive: boolean = false;
    constructor(rolesAndPermissions: RolesAndPermissionsApi) {
        if(!!rolesAndPermissions) {
            this.isActive = rolesAndPermissions.application.status === "Active";
            var globalRoles = rolesAndPermissions.application.roles;
            this.applicationPermissions = new ApplicationPermissions(globalRoles.map(x => x.name), globalRoles.filter(x => this.isActive).flatMap(x => x.permissions.flatMap(x => x.permissions)).map(x => new Permission(x.name)));
            var companyPolicies = rolesAndPermissions.application.policies.filter(x => x.policyTemplateName === "Company" && x.status === "Active");
    
            companyPolicies.map(x => {
                this.companyPermissions.push(new CompanyPermissions(x.name, x.roles.map(y => y.name), x.roles.flatMap(y => y.permissions).flatMap(x => x.permissions).map(x => new Permission(x.name))))
            });
        }
    }


    hasPermission(permission: Permission, forCompany: string = null) {
        if(!this.applicationPermissions) return false;
        var hasApplicationPermission =  this.applicationPermissions.permissions.map(x => x.name).indexOf(permission.name) >= 0;
        if(hasApplicationPermission) return true;

        if(forCompany) {
            var companyPermissions = this.companyPermissions.find(x => x.companyName === forCompany);
            if(companyPermissions) {
                return companyPermissions.permissions.map(x => x.name).indexOf(permission.name) >= 0;
            }
        }
        return false;
    }

    hasApplicationRole() {

        return this.applicationPermissions && this.applicationPermissions.roles.some(x => true);
    }

    hasElevatedRoleOrCompanyAccess() {
        return (this.applicationPermissions != null && this.applicationPermissions.roles.some(x => x != "User")) || (this.companyPermissions != null && this.companyPermissions.some(x => x.permissions.some(y => true)));
    }

}
